import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import i18n from '../i18n';

export default function TechniqueCueBubbleInline({ cue }) {
  const { t } = useTranslation();
  const lang = (i18n.language || 'en').startsWith('pt') ? 'pt' : 'en';
  if (!cue) return null;
  const text = lang === 'pt' ? (cue.text_pt || cue.text_en) : (cue.text_en || cue.text_pt);
  if (!text) return null;
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md bg-blue-500/10 border border-blue-500/30 px-3 py-2 text-sm text-blue-900 dark:text-blue-200 mt-1"
      data-testid="technique-cue-bubble"
    >
      <MessageCircle className="h-4 w-4 shrink-0 mt-0.5 text-blue-500" />
      <span className="leading-snug">
        <span className="font-semibold">{t('techniqueCues.coachTip')}: </span>
        {text}
      </span>
    </div>
  );
}
